import { IGetState, TBoardId } from '../../../types/types';
import { Dispatch, ThunkAction } from '../../../types/actions';
import { getRest } from './api/getRest';
import { getBoardUserMeta } from 'app/store/model/boardUserMetas/selectors/getBoardUserMeta';
import { boardUserMetasActionSetAction } from 'app/store/model/actions/boardUserMetasActionSetAction';
import { boardUserMetasActionSet } from 'app/store/model/boardUserMetas/actions/boardUserMetaActionSet';
import { updateAction } from 'app/store/model/boardUserMeta/actions/updateAction';

export const loadWebhooks = (
    boardId: TBoardId,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(getRest(boardId)).then((webhooks: any) => {
            const userMeta = {
                ...getBoardUserMeta(getState(), boardId),
                webhooks: webhooks,
            };
            dispatch(boardUserMetasActionSetAction(boardUserMetasActionSet(boardId, updateAction(userMeta))));
        });
    };
    return action;
}
